import React from 'react'

export default function AccountBadge({ name, logoUrl, size = 'md' }) {
  const sizes = {
    sm: 'w-12 h-12 text-xl',
    md: 'w-20 h-20 text-3xl',
    lg: 'w-24 h-24 text-4xl'
  }

  return (
    <div className={`${sizes[size]} bg-white rounded-xl shadow-lg flex items-center justify-center overflow-hidden`} role="img" aria-label={`${name} logo`}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className="w-full h-full object-contain p-1.5" />
      ) : (
        <span className="font-bold text-sky-900" aria-hidden="true">
          {name.charAt(0)}
        </span>
      )}
    </div>
  )
}
